import { h, render } from 'preact';

import I18n from '@/app/i18n';
import Theme from '@/app/theme';
import { setMeta } from '@/app/meta';
import Dispatcher from '@/app/dispatcher';
import { getComponent } from '@/app/widget';

import App from '@/components/';

export default class ReactDispatcher extends Dispatcher {
    dispatch (requestedInstances) {
        const { lang, meta } = this.app;
        const application = this.app;

        I18n.locale = lang;
        setMeta(meta);

        requestedInstances.forEach(function (instance) {
            const { theme, type } = instance;
            const instanceTheme = Theme(theme);

            if (!instance['node']) return;
            getComponent(type).then(Component => {
                const Widget = Component.default;
                render((
                    <App i18n={I18n} theme={instanceTheme} app={application}>
                        <Widget { ...instance['config']} />
                    </App>
                ), instance['node'], instance['loadingNode']);
            });
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/dispatcher/react.js